import { render, staticRenderFns } from "./description-listing.vue?vue&type=template&id=1ace5140&scoped=true"
import script from "./description-listing.vue?vue&type=script&lang=ts"
export * from "./description-listing.vue?vue&type=script&lang=ts"
import style0 from "./description-listing.vue?vue&type=style&index=0&id=1ace5140&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace5140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ace5140')) {
      api.createRecord('1ace5140', component.options)
    } else {
      api.reload('1ace5140', component.options)
    }
    module.hot.accept("./description-listing.vue?vue&type=template&id=1ace5140&scoped=true", function () {
      api.rerender('1ace5140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/description/description-listing.vue"
export default component.exports